import { MomentModalRef } from '@pages/Search/components/MomentGrid/components/MomentModal/MomentModal';
import { SearchResultItem } from '@stores/Library/LibrarySearch';
import { Media } from '@typings/Media';
import { createContext, useContext, useRef, useState } from 'react';

interface MomentModalContextValue {
  openModal: (result: SearchResultItem, media: Media) => void;
  closeModal: () => void;
  isOpen: boolean;
  currentResult: SearchResultItem | null;
  currentMedia: Media | null;
}

const MomentModalContext = createContext<MomentModalContextValue | null>(null);

export const useMomentModal = () => {
  const context = useContext(MomentModalContext);
  if (!context) {
    throw new Error('useMomentModal must be used within a MomentModalProvider');
  }
  return context;
};

interface MomentModalProviderProps {
  children: React.ReactNode;
}

export const MomentModalProvider = ({ children }: MomentModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentResult, setCurrentResult] = useState<SearchResultItem | null>(null);
  const [currentMedia, setCurrentMedia] = useState<Media | null>(null);
  const momentModalRef = useRef<MomentModalRef>(null);

  const openModal = (result: SearchResultItem, media: Media) => {
    setCurrentResult(result);
    setCurrentMedia(media);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setCurrentResult(null);
    setCurrentMedia(null);
  };

  return (
    <MomentModalContext.Provider
      value={{
        openModal,
        closeModal,
        isOpen,
        currentResult,
        currentMedia,
      }}
    >
      {children}
    </MomentModalContext.Provider>
  );
};
